import { render, staticRenderFns } from "./cp_contact.vue?vue&type=template&id=8d27191a&scoped=true"
import script from "./cp_contact.vue?vue&type=script&lang=js"
export * from "./cp_contact.vue?vue&type=script&lang=js"
import style0 from "./cp_contact.vue?vue&type=style&index=0&id=8d27191a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d27191a",
  null
  
)

export default component.exports